import {Databases, Query} from "appwrite";
import {client, database_id} from "../lib/appwrite";
import {ContactItem} from "../types/contacts";
import {v4 as uuidv4} from "uuid";

const CONTACTS_COLLECTION_ID = "67d5a8a2000468ca2545"

const databases = new Databases(client);

export const contactsService = {
  async create(data: ContactItem): Promise<ContactItem> {
    try {
      const createdItem = await databases.createDocument(
        database_id,
        CONTACTS_COLLECTION_ID,
        uuidv4(),
        data
      ) as unknown as ContactItem;

      return createdItem;
    } catch (error) {
      throw error;
    }
  },

  async update(data: ContactItem): Promise<ContactItem> {
    try {
      const id = data.$id as string
      const {$id, ...correctData} = data
      const updatedItem = await databases.updateDocument(
        database_id,
        CONTACTS_COLLECTION_ID,
        id,
        correctData
      ) as unknown as ContactItem;
      return updatedItem;
    } catch (error) {
      throw error;
    }
  },

  async delete(id: string): Promise<void> {
    try {
      await databases.deleteDocument(
        database_id,
        CONTACTS_COLLECTION_ID,
        id
      );
    } catch (error) {
      throw error;
    }
  },

  async list(queries: string[] = [], limit: number = 100): Promise<ContactItem[]> {
    try {
      const response = await databases.listDocuments(
        database_id,
        CONTACTS_COLLECTION_ID,
        [
          Query.limit(limit),
          ...queries
        ]
      );
      return response.documents.map(doc => doc as unknown as ContactItem);

    } catch (error) {
      // console.error('Error listing news:', error);
      throw error;
    }
  },
}